import { CloudstoreHeader } from './cloudstore-header'
import { DefaultFooter } from './default-footer'
import { DefaultHeader } from './default-header'
import { TitanFooter } from './titan-footer'
import { TitanHeader } from './titan-header'

interface ClientComponentConfig {
  Header: () => Promise<JSX.Element> | JSX.Element
  Footer: () => JSX.Element
  title: string
  loginRequired: boolean
}

type ClientComponents = Record<'default', ClientComponentConfig> &
  Partial<Record<string, ClientComponentConfig>>

const clientComponents: ClientComponents = {
  default: {
    Header: DefaultHeader,
    Footer: DefaultFooter,
    title: 'FarmerGPT',
    loginRequired: true
  },
  titan: {
    Header: TitanHeader,
    Footer: TitanFooter,
    title: 'TitanGPT',
    loginRequired: false
  },
  cloudstore: {
    Header: CloudstoreHeader,
    Footer: DefaultFooter,
    title: 'CloudStoreGPT',
    loginRequired: false
  },
  kcbobcat: {
    Header: DefaultHeader,
    Footer: DefaultFooter,
    title: 'KCBobcatGPT',
    loginRequired: false
  },
  legacy: {
    Header: DefaultHeader,
    Footer: DefaultFooter,
    title: 'LegacyEquipmentGPT',
    loginRequired: false
  },
  rdo: {
    Header: DefaultHeader,
    Footer: DefaultFooter,
    title: 'RDOEquipmentGPT',
    loginRequired: false
  },
  greenway: {
    Header: DefaultHeader,
    Footer: DefaultFooter,
    title: 'GreenwayGPT',
    loginRequired: false
  },
  ignite: {
    Header: DefaultHeader,
    Footer: DefaultFooter,
    title: 'IgniteGPT',
    loginRequired: false
  },
  heritage: {
    Header: DefaultHeader,
    Footer: DefaultFooter,
    title: 'Heritage Chat',
    loginRequired: false
  },
  ontrack: {
    Header: DefaultHeader,
    Footer: DefaultFooter,
    title: 'OnTrackGPT',
    loginRequired: false
  },
  hlavinka: {
    Header: DefaultHeader,
    Footer: DefaultFooter,
    title: 'Hlavinka Chat',
    loginRequired: false
  }
}

export default clientComponents
